import script from "./ItemModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemModal.vue?vue&type=script&setup=true&lang=js"

import "./ItemModal.vue?vue&type=style&index=0&id=007562c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-007562c3"]])

export default __exports__